import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiUrlV1 } from "../../../config/config";
import { PiggyProfile, PiggyProfileGlobalSettings } from "../../../entities/piggyGame";
import { agent } from "../../../api";
import { handlerNeedUpdateProfiles } from "../piggyBankTableStore";
import { addNotification } from "../../Notification/notificateStore";

/**
 * Создание профиля игры piggy bank
 * 
 * @param {PiggyProfileGlobalSettings} data - данные глобальной формы для создания {@link PiggyProfileGlobalSettings}
 */
export const postPiggyProfile = createAsyncThunk(
  "piggy/post-profile",
  async (params: { data: PiggyProfileGlobalSettings }, thunksApi): Promise<PiggyProfile> => {
    try {
      const v3ProfileBody = {
        ...params.data,
        isSortMode: false,
        isMultiGame: false,
        game: 'piggyBank'
      }
      const response = await agent.post(
        `${apiUrlV1}/v3/organization/game/profile/create/from-global-settings`,
        {
          body: JSON.stringify(v3ProfileBody),
        }
      );
      if (response.ok) {
        const data = await response.json() as PiggyProfile;
        thunksApi.dispatch(handlerNeedUpdateProfiles());
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        return data;
      }
      if (!response.ok) {
        const data = await response.json() as { message: string[] | string };
        if (typeof (data.message) === 'object' && data.message.length > 0) {
          data.message.forEach(element => {
            thunksApi.dispatch(
              addNotification({ status: "error", text: element })
            );
          });
        }
        if (typeof (data.message) === 'string') {
          thunksApi.dispatch(
            addNotification({ status: "error", text: data.message })
          );
        }
      }

      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

/**
 * Получение профиля игры по id piggy bank
 * 
 * @param {number} id - ID профиля 
 * 
 * @returns {PiggyProfile} возвращает профиль игры типа {@link PiggyProfile}
 */
export const getPiggyProfile = createAsyncThunk(
  "piggy/get-profile",
  async (params: { id: number }, thunksApi): Promise<PiggyProfile> => {
    try {
      const response = await agent.get(`${apiUrlV1}/v3/organization/game/profile/read/${params.id}`);
      if (response.ok) {
        const data = await response.json() as PiggyProfile;
        return data;
      }

      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

/**
 * Изменение профиля игры piggy bank
 * 
 * @param {any} data - данные глобальной формы для создания
 * @param {number} id - id профиля
 * b
 * @returns {PiggyProfile} возвращает профиль игры типа {@link PiggyProfile}
 */
export const patchPiggyProfile = createAsyncThunk(
  "piggy/patch-profile",
  async (params: {
    data: {
      globalSettings?: PiggyProfileGlobalSettings,
      configuration?: {
        gameEntities: {
          gameEntityId: number,
          index: number,
        }[]
      }
    }, id: number
  }, thunksApi): Promise<PiggyProfile> => {
    try {
      const response = await agent.patch(
        `${apiUrlV1}/v3/organization/game/profile/update/from-config-part/${params.id}`,
        {
          body: JSON.stringify(params.data),
        }
      );
      if (response.ok) {
        const data = await response.json() as PiggyProfile;
        thunksApi.dispatch(handlerNeedUpdateProfiles());
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        return data;
      }
      if (!response.ok) {
        const data = await response.json() as { message: string[] | string };
        if (typeof (data.message) === 'object' && data.message.length > 0) {
          data.message.forEach(element => {
            thunksApi.dispatch(
              addNotification({ status: "error", text: element })
            );
          });
        }
        if (typeof (data.message) === 'string') {
          thunksApi.dispatch(
            addNotification({ status: "error", text: data.message })
          );
        }
      }
      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);
